
export default function Pricing() {
  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">料金</h2>
          <p className="text-lg text-gray-600">
            1つのテーマ（主題）について「手数料」＋「実費（データベース使用料）」＋「精査料」で構成されています。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {/* 手数料 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#eb4b3f] to-[#f0945b] rounded-full mb-6 shadow-lg mx-auto">
              <i className="ri-hand-coin-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">手数料</h3>
            
            <div className="space-y-6">
              <div className="bg-gradient-to-r from-[#eb4b3f]/10 to-[#f0945b]/10 rounded-xl p-6 border border-[#eb4b3f]/20">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-700 font-semibold">1言語の場合</span>
                  <span className="text-3xl font-bold text-[#eb4b3f]">5,000円</span>
                </div>
                <p className="text-sm text-gray-600">（例:日本語のみ）</p>
              </div>

              <div className="bg-gradient-to-r from-[#f0945b]/10 to-[#eb4b3f]/10 rounded-xl p-6 border border-[#f0945b]/20">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-700 font-semibold">2言語の場合</span>
                  <span className="text-3xl font-bold text-[#f0945b]">10,000円</span>
                </div>
                <p className="text-sm text-gray-600">（例:日本語＋英語）</p>
              </div>
            </div>
          </div>

          {/* 実費 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#f0945b] to-[#eb4b3f] rounded-full mb-6 shadow-lg mx-auto">
              <i className="ri-database-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">実費（データベース使用料）</h3>
            
            <div className="bg-[#eb4b3f]/5 rounded-xl p-6 border border-[#eb4b3f]/20 mb-6">
              <p className="text-sm text-gray-700 text-center font-semibold mb-4">
                ※検索内容によって変動します。
              </p>
              
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <p className="text-sm text-gray-700 mb-3">
                  日本語のみの検索で、検索結果が20件あった場合の例:
                </p>
                
                <div className="space-y-2">
                  <div className="flex justify-between items-center pb-2 border-b border-gray-200">
                    <span className="text-gray-700 text-sm">実費:</span>
                    <span className="font-bold text-gray-800">約4,000円</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-xl p-4 border border-amber-200">
              <div className="flex items-start gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-amber-500 rounded-full flex-shrink-0">
                  <i className="ri-information-line text-lg text-white"></i>
                </div>
                <p className="text-xs text-gray-700">
                  ※実費は検索内容・複雑さにより増減します。
                </p>
              </div>
            </div>
          </div>

          {/* 精査料 */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#eb4b3f] to-[#f0945b] rounded-full mb-6 shadow-lg mx-auto">
              <i className="ri-file-search-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">精査料</h3>
            
            <div className="bg-gradient-to-r from-[#eb4b3f]/10 to-[#f0945b]/10 rounded-xl p-6 border border-[#eb4b3f]/20 mb-6">
              <div className="text-center mb-4">
                <span className="text-4xl font-bold text-[#eb4b3f]">1,000円〜</span>
              </div>
              <p className="text-sm text-gray-700 text-center">
                検索結果の精査・選定にかかる料金
              </p>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
              <div className="flex items-start gap-2">
                <div className="flex items-center justify-center w-8 h-8 bg-blue-500 rounded-full flex-shrink-0">
                  <i className="ri-information-line text-lg text-white"></i>
                </div>
                <p className="text-xs text-gray-700">
                  ※精査の内容や件数により料金が変動します。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 計算例 */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">〈料金計算例〉</h4>
            <p className="text-base text-gray-700 mb-6 text-center">
              日本語のみの検索で、検索結果が20件あった場合:
            </p>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                <span className="text-gray-700 font-semibold">手数料:</span>
                <span className="font-bold text-gray-800 text-lg">5,000円</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                <span className="text-gray-700 font-semibold">実費:</span>
                <span className="font-bold text-gray-800 text-lg">約4,000円</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                <span className="text-gray-700 font-semibold">精査料:</span>
                <span className="font-bold text-gray-800 text-lg">1,000円〜</span>
              </div>
              <div className="flex justify-between items-center pt-3">
                <span className="text-xl font-bold text-gray-800">合計:</span>
                <span className="text-3xl font-bold text-[#eb4b3f]">約10,000円〜</span>
              </div>
            </div>

            <div className="mt-6 bg-gradient-to-r from-amber-50 to-amber-100 rounded-xl p-5 border border-amber-200">
              <div className="flex items-start gap-3">
                <div className="flex items-center justify-center w-10 h-10 bg-amber-500 rounded-full flex-shrink-0">
                  <i className="ri-alert-line text-xl text-white"></i>
                </div>
                <div className="space-y-2">
                  <p className="text-sm text-gray-700 font-semibold">
                    ※検索結果が０件だった場合も料金は発生いたします。予めご了承ください。
                  </p>
                  <p className="text-sm text-gray-700">
                    ※SDI検索料金は別途ご相談ください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
